var moduleMap = {
	"./IdCheckFormRemote": () => {
		return Promise.all([__webpack_require__.e("vendors-node_modules_immer_dist_immer_mjs-node_modules_reselect_dist_reselect_mjs"), __webpack_require__.e("vendors-node_modules_emotion_is-prop-valid_dist_emotion-is-prop-valid_esm_js-node_modules_rea-8c8803"), __webpack_require__.e("webpack_sharing_consume_default_styled-components_styled-components"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_mixins_source-web-es_mixins"), __webpack_require__.e("webpack_sharing_consume_default_i18next_i18next-webpack_sharing_consume_default_react-i18next-172de6"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_icon_source-web-es_icon"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_styles_source-web-es_styles"), __webpack_require__.e("src_components_layout_utils_ts-src_containers_idcheck-form_idcheck-form_tsx-src_containers_id-a98cf8"), __webpack_require__.e("webpack_sharing_consume_default_source-web-es_button_source-web-es_button"), __webpack_require__.e("src_containers_app_app_tsx-src_hooks_useTranslation_ts")]).then(() => (() => ((__webpack_require__(7020)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});